export const JIRA_SITE_URL = 'https://badevhub.atlassian.net/';

export const URL_VALIDATION_REGEX = /^(http|https):\/\/[^ ]+$/;

export const flagTypes = {
  issue: 'ISSUE',
  improvement: 'IMPROVEMENT',
  help: 'HELP',
  additionalWorkRequired: 'ADDITIONAL_WORK_REQUIRED',
  notComplete: 'NOT_COMPLETE',
};

export const flagStatus = {
  open: 'OPEN',
  closed: 'CLOSED',
};

export const flagPriority = {
  urgent: 'URGENT',
  immediate: 'IMMEDIATE',
  planning: 'PLANNING',
  high: 'HIGH',
  medium: 'MEDIUM',
  normal: 'NORMAL',
  low: 'LOW',
  na: 'NA',
};

export const ISSUE_PAGE_SAVED_ROW_ID = 'SAVED_ROW_ID';
export const ISSUE_PAGE_SAVED_PAGE_NUMBER = 'SAVED_PAGE_NUMER';
